module.exports = __webpack_public_path__ + "static/media/dataak-without-logo.15599296.svg";